import { NativeSupportHandlerLegacy } from '@bharatpe/native-support-handler';
import Toasty from 'components/atoms/Toasty';
import { APP_VERSION, LOCALE, TOKEN_SESSION_KEY } from './CONSTANT';
import { removeState } from './LocalStorage';

export const isProd = (): boolean => true;

export const isIOS = (): boolean => {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
};

export const initImmediateNativeSupport = (): void => {
	try {
		if (isIOS()) {
			NativeSupportHandlerLegacy.initImmediate();
		}
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const getCurrencyFormat = (amount: string | number): string => {
	if (!amount) return `₹0`;

	const formatted = Number(amount)
		.toFixed(2)
		.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,');

	// To remove trailing zeroes
	let i = formatted.length;
	while (formatted[i - 1] === '0') {
		i -= 1;
	}
	if (formatted[i - 1] === '.') i -= 1;

	return `₹${formatted.slice(0, i)}`;
};

export const capitalizeFirstLetter = (text: string): string => {
	return text.replace(/\b\w/g, (char) => char.toUpperCase()).replace(/\B\w/g, (char) => char.toLowerCase());
};

export const copyToClipboard = (text: string): void => {
	if (!navigator.clipboard) {
		return;
	}
	navigator.clipboard.writeText(text).then(
		() => {
			Toasty.success('Copied Successfully', { className: 'io-toast-success' });
		},
		(err) => {
			Toasty.error('Could not copy', { className: 'io-toast-success' });
		},
	);
};

export const handleLogOut = () => {
	removeState(TOKEN_SESSION_KEY, true);
	removeState(APP_VERSION, true);
	removeState(LOCALE, true);
	NativeSupportHandlerLegacy.logOut();
};

export const isAppStatusInPaidState = (status = ''): boolean => {
	const paidStates = ['PAID', 'BANK_REG_INIT'];
	return paidStates.includes(status?.toUpperCase());
};
